export default {
    category_lists: [],
    et_product_phrases: {},
    complete_sga: [],
    languajes: ['Español', 'Ingles', 'Portugues'],
    types: [
        {text: 'Codigo', value: '0'},
        {text: '*', value: '1'},
        {text: 'Sin separador', value: '2'},
        {text: 'Enter', value: '3'},
        {text: '-', value: '4'}
    ],
    languaje: 'Español',
    type: '0',
    filter: {
        product_id: null,
        company_id: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
}



